import { jsx as b, jsxs as M, Fragment as N } from "react/jsx-runtime";
import { Checkbox as q } from "@blueprintjs/core";
import y from "classnames";
import "./main.scss";
import { FormFieldWrapper as B } from "@strata/react-form-field-wrapper";
import { getValidationMessage as C } from "@strata/helper-functions";
import { Field as E } from "formik";
const j = ({
  checked: e,
  indeterminate: r,
  onChange: t,
  name: l,
  label: d = void 0,
  disabled: n = !1,
  inline: o,
  onBlur: s,
  autoFocus: f = !1,
  tabIndex: i,
  inputRef: h,
  className: k,
  style: p
}) => /* @__PURE__ */ b(
  q,
  {
    name: l,
    className: y("sds_checkbox", "sds_checkbox__button-text", k),
    style: p,
    labelElement: d,
    disabled: n,
    inline: o,
    checked: e,
    indeterminate: r,
    onChange: (m) => t(m.target.checked),
    onBlur: s,
    autoFocus: f,
    tabIndex: i,
    inputRef: h
  }
), V = (e) => {
  const r = typeof e == "object", t = r ? e.value : e, l = r ? e.component ?? e.text : e;
  return { value: t, optionLabel: l };
}, W = ({
  name: e,
  options: r,
  values: t = [],
  onChange: l = void 0,
  label: d = "",
  helperText: n,
  disabled: o = !1,
  inline: s = !1,
  fill: f,
  inlineItems: i = void 0,
  required: h = !1,
  requiredValidationMessage: k,
  verticalSpacingSmall: p = !0,
  onBlur: m,
  autoFocus: F = !1,
  tabIndex: g,
  inputRef: v,
  showSelectAll: u = !1
}) => /* @__PURE__ */ b(
  B,
  {
    label: d,
    labelFor: e,
    disabled: o,
    helperText: n,
    inline: s,
    fill: f,
    required: h,
    requiredValidationMessage: k,
    verticalSpacingSmall: p,
    inputContent: /* @__PURE__ */ M(N, { children: [
      u && /* @__PURE__ */ b(
        j,
        {
          name: e,
          label: "Select all",
          disabled: o,
          inline: s || i,
          tabIndex: g,
          autoFocus: F,
          inputRef: v,
          onBlur: m,
          checked: t.length === r.length,
          indeterminate: t.length > 0 && t.length < r.length,
          onChange: (x) => {
            l == null || l(
              x ? r.map((c) => V(c).value) : []
            );
          }
        }
      ),
      r.map((x, c) => {
        const { value: a, optionLabel: L } = V(x);
        return /* @__PURE__ */ b(
          j,
          {
            name: e,
            label: L,
            disabled: o,
            inline: s || i,
            checked: t.includes(a),
            tabIndex: g,
            autoFocus: !u && c === 0 && F,
            inputRef: !u && c === 0 ? v : void 0,
            onBlur: m,
            onChange: (_) => {
              l == null || l(
                _ ? [...t, a] : t.filter((O) => O !== a)
              );
            }
          },
          a
        );
      })
    ] })
  }
), P = ({
  name: e,
  options: r,
  values: t,
  onChange: l,
  label: d,
  helperText: n,
  disabled: o,
  inline: s,
  fill: f,
  inlineItems: i,
  required: h,
  requiredValidationMessage: k,
  verticalSpacingSmall: p,
  onBlur: m,
  autoFocus: F,
  tabIndex: g,
  inputRef: v,
  showSelectAll: u,
  validate: x = void 0
}) => /* @__PURE__ */ b(E, { name: e, validate: x, children: ({ field: c, form: a }) => /* @__PURE__ */ b(
  W,
  {
    name: e,
    options: r,
    values: t ?? c.value,
    onChange: l ?? ((L) => a.setFieldValue(c.name, L)),
    onBlur: m ?? a.handleBlur,
    label: d,
    helperText: n,
    disabled: o,
    inline: s,
    fill: f,
    inlineItems: i,
    required: h,
    requiredValidationMessage: k ?? C(c.name, a),
    verticalSpacingSmall: p,
    autoFocus: F,
    tabIndex: g,
    inputRef: v,
    showSelectAll: u
  }
) });
export {
  j as Checkbox,
  W as CheckboxList,
  P as CheckboxListFormik
};
//# sourceMappingURL=index.js.map
